import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { ExcelRenderer } from "react-excel-renderer";
// import Table from "../../table";
import StepTitle from "../../StepTitle";
import ButtonGroup from "../../buttonGroup";
import Helper from "../../../universe_lite/helper/Helper";
import TreeTableHolder from "./TreeTableHolder";
import "./security.styles.scss";
import Pannel from "../../Analyze/pannel";
import { uniqueId } from "lodash";

class Security extends Component {
  // constructor(){
  //   super()

  // }

  state = {
    securityUploadError: false,
    securityUploadErrorName: "",
    wrongFormat: false,
    uploaded_symbol_not_matching_to_myUniverse_symbol: false,
    showAddRowModel: false,
    portfolioTableActive: true,
  };

  // upload excel file portfolios
  xlsxEvent = (event) => {
    const { setUniverseLitePortfolio, analyzeExistingActive, myUniverse } =
      this.props;
    var file = event.target.files[0];
    if (
      file &&
      file.name &&
      (file.name.includes(".xls") || file.name.includes(".xlsx"))
    ) {
      ExcelRenderer(file, (err, res) => {
        if (err) {
          console.log("Error");
        } else {
          var response = res["rows"];

          // checks if any null or empty data and removes it
          let resData = response.filter((d) => d.length);
          let filtered =
            resData &&
            resData.map((d) => {
              return d.filter((el) => el != null);
            });
          var filteredData = filtered.filter((d) => d.length);

          console.log(resData, "response");
          var heading =
            filteredData && filteredData[0].map((e) => e.toLowerCase());
          var data = filteredData.slice(1, filteredData.length);

          const getIndex = (data, string) => {
            return data.indexOf(string);
          };
          let security_index = getIndex(heading, "security");
          let symbol_index = getIndex(heading, "symbol");
          let fund_type_index = getIndex(heading, "fund type");
          let classification_index = getIndex(heading, "classification");
          let asset_class_index = getIndex(heading, "asset class");
          let style_index = getIndex(heading, "style");
          let core_allocation_index = getIndex(heading, "allocation");

          // getting which column has error
          const getStatus = () => {
            if (security_index === -1) {
              setValue("security");
              return;
            } else if (symbol_index === -1) {
              setValue("symbol");
              return;
            } else if (fund_type_index === -1) {
              setValue("fund type");
              return;
            } else if (classification_index === -1) {
              setValue("classification");
              return;
            } else if (asset_class_index === -1) {
              setValue("asset class");
              return;
            } else if (style_index === -1) {
              setValue("style");
              return;
            } else if (core_allocation_index === -1) {
              if (analyzeExistingActive) {
                setValue("allocation");
              }
              return;
            }
          };
          const setValue = (name) => {
            this.setState({
              securityUploadErrorName: name,
            });
          };
          getStatus();

          let condition;

          if (!analyzeExistingActive) {
            condition =
              (heading[security_index] === "security" ||
                security_index !== -1) &&
              (heading[symbol_index] === "symbol" || symbol_index !== -1);
          } else {
            condition =
              ((heading[security_index] === "security" ||
                security_index !== -1) &&
                (heading[symbol_index] === "symbol" || symbol_index !== -1) &&
                (heading[fund_type_index] === "fund type" ||
                  fund_type_index !== -1) &&
                (heading[classification_index] === "classification" ||
                  classification_index !== -1) &&
                (heading[asset_class_index] === "asset class" ||
                  asset_class_index !== -1) &&
                (heading[style_index] === "style" || style_index !== -1) &&
                heading[core_allocation_index] === "allocation") ||
              core_allocation_index !== -1;
          }

          let validate_uploaded_symbols_with_myUniverse = ({
            uploaded_symbols,
            my_universe_symbols,
          }) => {
            let status;

            if (uploaded_symbols && my_universe_symbols) {
              status = uploaded_symbols.every((el) => {
                return my_universe_symbols.indexOf(el) !== -1;
              });
            } else {
              status = false;
            }
            return status;
          };

          let list_of_uploaded_symbols = data.map((e) => e[symbol_index]);
          let my_universe_symbols = myUniverse.map((e) => e.symbol);

          let symbol_validate_with_myUniverse =
            validate_uploaded_symbols_with_myUniverse({
              uploaded_symbols: list_of_uploaded_symbols,
              my_universe_symbols: my_universe_symbols,
            });

          if (
            heading.length > 0 &&
            condition &&
            symbol_validate_with_myUniverse
          ) {
            let arr = [];
            for (let i = 0; i < data.length; i++) {
              let obj = {};
              obj.fund_name = data[i][security_index];
              obj.symbol = data[i][symbol_index];
              obj.new_fund_type = data[i][fund_type_index];
              obj.new_classification = data[i][classification_index];
              obj.fund_asset_class_focus = data[i][asset_class_index];
              obj.new_style = data[i][style_index];
              obj.initial_allocation =
                data[i][core_allocation_index] && analyzeExistingActive
                  ? data[i][core_allocation_index] * 1
                  : null;
              obj.val =
                data[i][core_allocation_index] && analyzeExistingActive
                  ? data[i][core_allocation_index] * 1
                  : null;
              obj.action = "keep";
              obj.addedRow = false;
              arr.push(obj);
            }

            //  setting default cash row
            let cashFind = arr.filter(
              (d) => d.fund_name.toLowerCase() === "cash"
            );

            if (cashFind.length === 0) {
              let obj = {
                action: "keep",
                fund_asset_class_focus: "Cash",
                fund_name: "Cash",
                initial_allocation: 0,
                new_classification: "Cash",
                new_style: "Cash",
                symbol: "IQCASH",
                val: 0,
              };
              let ar = [obj, ...arr];
              setUniverseLitePortfolio(ar);
            } else {
              setUniverseLitePortfolio(arr);
            }
            // setUniverseLitePortfolio(arr);
            this.setState({
              securityUploadError: false,
              uploaded_symbol_not_matching_to_myUniverse_symbol: false,
            });

            // setting limit step data based on uploaded
            if (
              arr &&
              arr.length &&
              this.props.analyzeExistingActive === false
            ) {
              let data;
              let ID = this.props.activePortfolioID;
              let upperBound =
                this.props.optimization_params[ID]["upper_bounds"] * 1;
              data = Helper.getLimitsDataFromSymbols(arr, upperBound);
              this.props.setBackendParam_Security_Universe_limits(data);

              document.getElementById("upload_scenario_file02").value = "";
            }
          } else {
            // invalid excel data
            console.log("invalid excel data");
            if (condition && symbol_validate_with_myUniverse === false) {
              this.setState({
                uploaded_symbol_not_matching_to_myUniverse_symbol: true,
              });

              setTimeout(() => {
                this.setState({
                  uploaded_symbol_not_matching_to_myUniverse_symbol: false,
                });
              }, 10000);
            } else {
              this.setState({
                securityUploadError: true,
              });
            }

            document.getElementById("upload_scenario_file02").value = "";
          }
        }
      });
    } else {
      this.setState({
        wrongFormat: true,
      });

      setTimeout(() => {
        this.setState({
          wrongFormat: false,
        });
      }, 5000);
      document.getElementById("upload_scenario_file02").value = "";
    }
  };

  resetErrorUploadedPortfolio = () => {
    this.setState({
      securityUploadError: false,
    });
  };

  Warning = (children) => {
    return (
      <div className="universe_note">
        <span className="dataWarning" style={{ marginLeft: "auto" }}>
          {children}
        </span>
      </div>
    );
  };

  //============*Pannelconfig*===============
  addRowHandler = () => {
    this.setState({
      showAddRowModel: !this.state.showAddRowModel,
    });
  };
  addRowToggleHandler = () => {
    this.setState({
      showAddRowModel: !this.state.showAddRowModel,
    });
  };
  callBack = () => {
    this.setState({
      portfolioTableActive: false,
    });
  };

  //==============================

  //============**===============

  render() {
    const {
      activePortfolioID,
      styles,
      asset_class,
      overall_focus,
      optimization_params,
      portfolio,
    } = this.props;
    const {
      securityUploadError,
      securityUploadErrorName,
      wrongFormat,
      uploaded_symbol_not_matching_to_myUniverse_symbol,
    } = this.state;
    console.log("security rendered");
    return (
      <Fragment>
        <div
          style={{
            display: "flex",
            width: "100%",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <StepTitle />
          <ButtonGroup
            xlsxEvent={this.xlsxEvent}
            securityUploadError={securityUploadError}
            resetErrorUploadedPortfolio={this.resetErrorUploadedPortfolio}
          />
        </div>
        {securityUploadError
          ? this.Warning(
              `${securityUploadErrorName.toUpperCase()} column missing. Please make sure "${securityUploadErrorName}"
  column exists in the uploaded portfolio excel. `
            )
          : null}
        {uploaded_symbol_not_matching_to_myUniverse_symbol
          ? this.Warning(
              "Uploaded Securities are not matching to Universe securities."
            )
          : null}
        {wrongFormat
          ? this.Warning("Please upload xls/xlsx format data.")
          : null}
        {/* <Table
          changeHandle={changeHandle}
          setUniverseLiteAction={setUniverseLiteAction}
        /> */}
        <div className="Pannel ">
          <Pannel
            showAddRowModel={this.state.showAddRowModel}
            addRowHandler={this.addRowHandler}
            addRowToggleHandler={this.addRowToggleHandler}
            callBack={this.callBack}
            AddManualSecurityMyUniverse={true}
            AddManualSecurity={true}
          />
        </div>
        <TreeTableHolder
          activePortfolioID={activePortfolioID}
          getScenarioShortlist={portfolio}
          overall_focus={overall_focus}
          asset_class={asset_class}
          styles={styles}
          optimization_params={optimization_params}
          validate_slider_limits={true}
        />
        <table
          className="table bordered striped"
          id="universe_lite"
          style={{ display: "none" }}
        >
          <thead>
            <tr>
              <th>Security</th>
              <th>Symbol</th>
              <th>Fund Type</th>
              <th>Classification</th>
              <th>Asset Class</th>
              <th>Style</th>
              <th>Allocation</th>
            </tr>
          </thead>
          <tbody>
            {portfolio.map((item, i = uniqueId()) => {
              return (
                <tr key={i}>
                  <td>{item.fund_name}</td>
                  <td>{item.symbol}</td>
                  <td>{item.new_fund_type}</td>
                  <td>{item.new_classification}</td>
                  <td>{item.fund_asset_class_focus}</td>
                  <td>{item.new_style}</td>
                  <td>{item.val}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Fragment>
    );
  }
}

export default connect(
  ({
    create: {
      steps: {
        backendParams: {
          styles,
          asset_class,
          overall_focus,
          optimization_params,
        },
        universeLite: {
          portfolio,
          portfolioActive,
          allocationSumError,
          analyzeExistingActive,
        },
        risk: { activePortfolioID },
      },
    },
  }) => ({
    portfolio,
    portfolioActive,
    allocationSumError,
    styles,
    asset_class,
    overall_focus,
    optimization_params,
    analyzeExistingActive,
    activePortfolioID,
  }),
  (dispatch) => ({
    setPortfolioName: (value) =>
      dispatch({ type: "SET_PORTFOLIO_NAME", payload: value }),
    changeHandle: (i, key, value) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_SYMBOL_VALUE",
        payload: { i, key, value },
      }),
    setUniverseLitePortfolio: (payload) =>
      dispatch({ type: "SET_UNIVERSE_LITE_PORTFOLIO", payload }),
    addRow: () => dispatch({ type: "ADD_UNIVERSE_LITE_DATA" }),

    setUniverseLiteAction: (i, key, value) =>
      dispatch({
        type: "SET_UNIVERSE_LITE_ACTION",
        payload: { i, key, value },
      }),
    setAllocatioError: (value) =>
      dispatch({
        type: "ALLOCATION_SUM_ERROR",
        payload: value,
      }),
    setBackendParam_Security_Universe_limits: (payload) =>
      dispatch({
        type: "SET_BACKENDPARAMS_SECURITY_UNIVERSE_LIMITS_DATA",
        payload,
      }),
  })
)(Security);



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Security/security_universe/security.jsx